<template>
  <div class="content">
    <el-form :model="queryParams" ref="queryForm"  :inline="true" label-width="68px">
      <el-form-item  prop="userId">
        <el-cascader
            placeholder="代理商"
            ref="myCascader"
            :options="agentTree"
            :props="{ value : 'userId' , label : 'name' , checkStrictly: true,emitPath : false }"
            :show-all-levels="false"
            clearable
            v-model="queryParams.userId"
            @change="search"
            filterable
        ></el-cascader>
      </el-form-item>
      <el-form-item prop="isShow">
        <el-select v-model="queryParams.isShow" filterable clearable placeholder="是否上架" @change="search">
          <el-option v-for="item in isshow" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search"  @click="search">搜索</el-button>
        <el-button icon="el-icon-refresh"  @click="resetQuery">重置</el-button>
        <el-button type="primary" icon="el-icon-plus" @click="addItem">添加</el-button>
      </el-form-item>
    </el-form>
    <div class="table">
      <el-table :data="tableData" border id="out-table">
        <el-table-column prop="ids" label="序号" align="center" width="60px"></el-table-column>
        <el-table-column prop="company" label="代理商" align="center" width="260px"></el-table-column>
        <el-table-column prop="productName" label="资费套餐" align="center" width="230px">
          <template slot-scope="scope">
            <div v-if="showAdmin">【{{scope.row.productId}}】{{scope.row.productName}}</div>
            <div v-else>{{scope.row.productName}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="type" label="类型" align="center" width="100px">
          <template slot-scope="scope">
            <div v-if="scope.row.type == '1'">流量套餐</div>
            <div v-if="scope.row.type == '2'">短信套餐</div>
            <div v-if="scope.row.type == '3'">国际套餐</div>
          </template>
        </el-table-column>
        <el-table-column label="简介" align="center" width="840px">
          <template slot-scope="{row}">
            <div class="product-list">
              <div class="product-item" v-for="(item,index) in row.unitProducts" :key="index" 
                    :title="'【'+item.countryName+'】' + item.operationName+'：' +'底价('+ item.currencySymbol + item.basePrice +')'+' 售价('+item.currencySymbol + item.price +')'+' 市场价('+item.currencySymbol + item.marketPrice +')'">

                    <span>【{{item.countryName}}】{{item.operationName}}：</span><span style="margin-left:10px">底价({{item.currencySymbol}}{{item.basePrice}})</span>
                    <span style="margin-left:10px">售价({{item.currencySymbol}}{{item.price}}) </span>
                    <span style="margin-left:10px" v-if="item.marketPrice>0">市场价({{item.currencySymbol}}{{item.marketPrice}})</span>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="isShow" label="是否上架" align="center">
          <template slot-scope="{row}">
            <el-tag v-if="row.isShow == '1'">已上架</el-tag>
            <el-tag v-if="row.isShow == '0'" type="danger">未上架</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="120">
          <template slot-scope="{row}">
            <el-button size="mini" type="primary" plain  icon="el-icon-edit" @click="handleEdit(row)" >编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <pagination
      v-show="total>0"
      :total="total"
      :page.sync="page"
      :limit.sync="pageSize"
      @pagination="queryInfo"
    />
    <div>
    <el-dialog :title="title" :visible.sync="dialog" @close="dialogClose" :lock-scroll="false" width="60%" v-dialogDrag :close-on-click-modal="false">
      <el-form :model="propsParams" :rules="ruleValidate" ref="propsParams">
        <el-form-item label="代理商:" prop="userId" :label-width="LabelWidth" >
          <el-cascader style="width: 100%"
              v-show="!useridDisabled"
              placeholder="代理商"
              ref="myCascader"
              :options="agentTree"
              :props="{ value : 'userId' , label : 'name' , checkStrictly: true,emitPath : false }"
              :show-all-levels="false"
              clearable
              v-model="propsParams.userId"
              filterable></el-cascader>
          <el-input v-show="useridDisabled" v-model="propsParams.company" disabled  style="width: 100%"></el-input>
        </el-form-item>
        <el-form-item label="资费套餐:" prop="productId" :label-width="LabelWidth">
          <el-select v-model="propsParams.productId" filterable placeholder="请选择资费套餐" style="width: 100%" @change="selectedPackage()" :disabled='serveridDisabled'>
            <el-option v-for="item in optPackage" :key="item.id" :label="item.id +'-'+item.productName" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-row>
          <el-col :span="12">
            <el-form-item  label="联通底价:" prop="ltBasePrice" :label-width="LabelWidth">
              <el-input v-model="propsParams.ltBasePrice" autocomplete="off" style="width: 100%"  placeholder="请输入联通底价" 
              :disabled='ltBasePriceDisabled'
              oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')">
                <template slot="prepend" v-if="!ltBasePriceDisabled">>{{baseForm.ltBasePrice}}</template>
                <template slot="append">元</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联通售价:" prop="ltPrice" :label-width="LabelWidth">
              <el-input v-model="propsParams.ltPrice" autocomplete="off" style="width: 100%"
              placeholder="请输入联通售价"
              oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')">>
                <template slot="prepend">>{{propsParams.ltBasePrice}}</template>
                <template slot="append">元</template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item  label="电信底价:" prop="dxBasePrice" :label-width="LabelWidth">
              <el-input v-model="propsParams.dxBasePrice" autocomplete="off" style="width: 100%" 
              placeholder="请输入电信底价" 
              :disabled='dxBasePriceDisabled'
              oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')">>
                <template slot="prepend" v-if="!dxBasePriceDisabled">>{{baseForm.dxBasePrice}}</template>
                <template slot="append">元</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="电信售价:" prop="dxPrice" :label-width="LabelWidth">
              <el-input v-model="propsParams.dxPrice" autocomplete="off" style="width: 100%" 
              placeholder="请输入电信售价"
              oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')">>
                <template slot="prepend">>{{propsParams.dxBasePrice}}</template>
                <template slot="append">元</template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item  label="移动底价:" prop="ydBasePrice" :label-width="LabelWidth">
              <el-input v-model="propsParams.ydBasePrice" autocomplete="off" style="width: 100%" 
              placeholder="请输入移动底价" 
              :disabled='ydBasePriceDisabled'
              oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')">>
                <template slot="prepend" v-if="!ydBasePriceDisabled">>{{baseForm.ydBasePrice}}</template>
                <template slot="append">元</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="移动售价:" prop="ydPrice" :label-width="LabelWidth">
              <el-input v-model="propsParams.ydPrice" autocomplete="off" style="width: 100%" 
              placeholder="请输入移动售价"
              oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')">>
                <template slot="prepend">>{{propsParams.ydBasePrice}}</template>
                <template slot="append">元</template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="市场价格:" prop="marketPrice" :label-width="LabelWidth">
          <el-input v-model="propsParams.marketPrice" autocomplete="off" style="width: 100%" 
          placeholder="请输入市场价格"
          oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')">>
            <template slot="append">元</template>
          </el-input>
        </el-form-item>
        <el-form-item label="是否上架:" prop="isShow" :label-width="LabelWidth" v-show="showUpOrDownProduct" >
        <el-switch
          v-model="propsParams.isShow"
          active-color="#13ce66"
          inactive-color="#DCDFE6"
          active-value="1"
          inactive-value="0"
        ></el-switch>
        </el-form-item>
      </el-form>
      <div class="dialog-footer" slot="footer">
        <el-button type="primary" @click="cancelDialog">取消</el-button>
        <el-button type="success" @click="saveDialog">确认</el-button>
      </div>
    </el-dialog>
    </div>
  </div>
</template>
<script>
import {agentTreeList} from "@/api/api.js"; //新建套餐代理商
import { addBaseProduct } from "@/api/api.js"; //新建低价套餐 
import { updateBaseProduct } from "@/api/api.js"; //编辑低价套餐 updateBaseProduct
import { selectProductList } from "@/api/api.js"; //资费套餐下拉01
import { baseProductPage } from "@/api/api.js"; //获取列表
import { baseProductInfo } from "@/api/api.js"; //编辑获取详情
import { getParentBaseProductInfo } from "@/api/api.js"; //底价套餐选择套餐id 出现对应的数据
export default {
  name: "proxy",
  data() {
      var checkLtBasePrice = (rule, value, callback) => {
        if (Number(value)<=this.baseForm.ltBasePrice) {
          return callback(new Error('联通底价必须大于' + this.baseForm.ltBasePrice +"元"));
        }
        callback();
      };
      var checkDxBasePrice = (rule, value, callback) => {
        if (Number(value)<=this.baseForm.dxBasePrice) {
          return callback(new Error('电信底价必须大于' + this.baseForm.dxBasePrice +"元"));
        }
        callback();
      };
      var checkYdBasePrice = (rule, value, callback) => {
        if (Number(value)<=this.baseForm.ydBasePrice) {
          return callback(new Error('电信底价必须大于' + this.baseForm.ydBasePrice +"元"));
        }
        callback();
      };
      var checkLtPrice = (rule, value, callback) => {
        if (Number(value)<this.propsParams.ltBasePrice) {
          return callback(new Error('联通售价必须大于' + this.propsParams.ltBasePrice +"元"));
        }
        callback();
      };
      var checkDxPrice = (rule, value, callback) => {
        if (Number(value)<this.propsParams.dxBasePrice) {
          return callback(new Error('电信售价必须大于' + this.propsParams.dxBasePrice +"元"));
        }
        callback();
      };
      var checkYdPrice = (rule, value, callback) => {
        if (Number(value)<this.propsParams.ydBasePrice) {
          return callback(new Error('移动售价必须大于' + this.propsParams.ydBasePrice +"元"));
        }
        callback();
      };
    return {
      useridDisabled:false,//代理商
      serveridDisabled:false,//资费套餐
      ltBasePriceDisabled:false,//底价
      dxBasePriceDisabled:false,//底价
      ydBasePriceDisabled:false,//底价
      showUpOrDownProduct:false,
      queryParams: {
        userId:undefined,
        isShow:undefined
      },
      tableData: [],
      // 分页器
      page: 1,
      pageSize: 20,
      total: 20,
      // 代理商
      agentTree: [],
      optPackage: [],
      level:'',
      title: "创建代理商资费",
      // 弹窗
      dialog: false,
      LabelWidth: "120px",
      propsParams: {
        ltBasePrice:0,
        dxBasePrice:0,
        ydBasePrice:0,
      },
      //基础
      baseForm:{
        ltBasePrice:0,
        dxBasePrice:0,
        ydBasePrice:0
      },
      //表单校验
      ruleValidate: {
        userId: [
          { required: true, message: "公司名", trigger: "blur" }
        ],
        productId: [
          { required: true, message: "请选择资费套餐", trigger: "blur" }
        ],
        ltBasePrice: [
          { required: true, message: "请输入联通底价", trigger: "blur" },
          { validator: checkLtBasePrice, trigger: 'blur' }
        ],
        ydBasePrice: [
          { required: true, message: "请输入移动底价", trigger: "blur" },
          { validator: checkYdBasePrice, trigger: 'blur' }
        ],
        dxBasePrice: [
          { required: true, message: "请输入电信底价", trigger: "blur" },
          { validator: checkDxBasePrice, trigger: 'blur' }
        ],
        ltPrice:[
          { required: true, message: "请输入联通售价", trigger: "blur" },
          { validator: checkLtPrice, trigger: 'blur' }
        ],
        dxPrice:[
          { required: true, message: "请输入电信售价", trigger: "blur" },
          { validator: checkDxPrice, trigger: 'blur' }
        ],
        ydPrice:[
          { required: true, message: "请输入移动售价", trigger: "blur" },
          { validator: checkYdPrice, trigger: 'blur' }
        ]
      },
      isshow:[
        {
          value: 0,
          label: "未上架"
        },
        {
          value: 1,
          label: "已上架"
        },
      ],
      baseId:null
    };
  },
  computed: {
    showAdmin(){
        return this.$store.getters.user.userType =='1'; 
    },
  },
  methods: {
    updateShow(show){
      this.queryInfo()
    },
    //代理商列表
    handleAgentTreeList(){
      agentTreeList().then(res => {
        this.agentTree = res.data.data;
      });
    },
    // 资费套餐下拉
    queryServerList() {
      selectProductList({}).then(res => {
        this.optPackage = res.data.data;
        if(!!this.optPackage){
          this.optPackage = this.optPackage.filter(item=> (item.type=='1' ||  item.type=='2'));
        }
        
      });
    },
    // 获取列表
    queryInfo() {
      let params = {
        model:{
          ...this.queryParams,
        },
        page: this.page,
        pageSize: this.pageSize,
      };
      baseProductPage(params).then(res => {
        if (res.data.code == 200) {
          this.total = res.data.data.total;
          this.tableData = res.data.data.records;
          this.tableData.map((item,index)=>{
            item.ids  = index + 1
            
          })
        }else{
          this.$message.error(res.data.message)
        }
      });
    },
    // 搜索
    search() {
      this.page = 1,
      this.queryInfo();
    },
    // 重置
    resetQuery() {
      this.resetForm("queryForm");
      this.queryInfo();
    },
    // 添加
    addItem() {
      this.dialog = true;
      this.title = "创建底价套餐";
      this.propsParams = {
        ltBasePrice:0,
        dxBasePrice:0,
        ydBasePrice:0,
      };
      this.useridDisabled = false;
      this.serveridDisabled = false;
      this.ltBasePriceDisabled = false;
      this.dxBasePriceDisabled = false;
      this.ydBasePriceDisabled = false;
      this.showUpOrDownProduct= true;
    },
    // 确定保存
    saveDialog() {
      this.$refs.propsParams.validate(valid => {
        if (valid) {
          let params = {
            ...this.propsParams,
          };
          if(this.title == "创建底价套餐"){
            addBaseProduct(params).then(res => {
              if (res.data.code == 200) {
                this.$message.success("创建底价套餐成功");
                this.dialog = false;
                this.queryInfo();
              }else{
                this.$message.error(res.data.message);
              }
            })
          }else{
            updateBaseProduct(params).then(res => {
              if (res.data.code == 200) {
                this.$message.success("编辑底价套餐成功");
                this.dialog = false;
                this.queryInfo();
              }else{
                this.$message.error(res.data.message);
              }
            })
          }
        }
      })
    },
    // 修改
    handleEdit(row) {
      if(row.type=='3'){
        this.baseId = row.id
        return
      }
      this.title = "编辑底价套餐";
      this.dialog = true;
      this.useridDisabled = true;
      this.serveridDisabled = true;
      if(this.showAdmin){
          this.showUpOrDownProduct = true;
      }
      if(!this.showAdmin){
        this.ltBasePriceDisabled = true;
        this.dxBasePriceDisabled = true;
        this.ydBasePriceDisabled = true;
        //控制显示下架按钮 自己建的可以控制上下架
        this.showUpOrDownProduct = false;
        let userId = localStorage.getItem("userId");
        if(row.userId != userId){
          this.ltBasePriceDisabled = false;
          this.dxBasePriceDisabled = false;
          this.ydBasePriceDisabled = false;
          this.showUpOrDownProduct = true;
        }
      }
      let params = {
        id: row.id
      };
      baseProductInfo(params).then(res => {
        if (res.data.code == 200) {
          this.propsParams = Object.assign({}, res.data.data);
          this.baseForm.dxBasePrice = res.data.data.supDxBasePrice;
          this.baseForm.ltBasePrice = res.data.data.supLtBasePrice;
          this.baseForm.ydBasePrice = res.data.data.supYdBasePrice;
        }
      })
    },
    cancelDialog() {
      this.dialog = false;
    },
    // 关闭弹窗
    dialogClose() {
      this.$refs.propsParams.clearValidate();
      this.baseForm ={
        ltBasePrice:0,
        dxBasePrice:0,
        ydBasePrice:0
      };
      this.dialog = false;
    },

    // 套餐选中
    selectedPackage(){
      if(!this.showAdmin){
        let params = {
          productId:this.propsParams.productId,
          userId:this.propsParams.userId
        };
        getParentBaseProductInfo(params).then(res=>{
          this.$set(this.propsParams,'ltBasePrice',res.data.data.ltBasePrice);
          this.$set(this.propsParams,'dxBasePrice',res.data.data.dxBasePrice);
          this.$set(this.propsParams,'ydBasePrice',res.data.data.ydBasePrice);
          this.$set(this.propsParams,'ltPrice',res.data.data.ltPrice);
          this.$set(this.propsParams,'dxPrice',res.data.data.dxPrice);
          this.$set(this.propsParams,'ydPrice',res.data.data.ydPrice );
          this.$set(this.propsParams,'marketPrice',res.data.data.marketPrice);

          this.baseForm.ltBasePrice = res.data.data.ltBasePrice;
          this.baseForm.dxBasePrice = res.data.data.dxBasePrice;
          this.baseForm.ydBasePrice = res.data.data.ydBasePrice;
        })
      }
    }
  },
  created() {

  },
  mounted() {
    this.queryInfo();
    this.queryServerList();
    this.handleAgentTreeList();
  }
};
</script>
<style scoped lang="less">
.product-list{
  display: flex; /* 或者 inline-flex */
  flex-wrap: wrap; /* 允许元素在需要时换行 */
  width: 820px;
  color: #409eff;
  .product-item{
    border: 1px solid #dcdfe6;
    width: 400px; /* 设置子元素的宽度 */
    white-space: nowrap;
    overflow: hidden; /* 隐藏超出容器的文本 */
    text-overflow: ellipsis; /* 使用省略号表示文本被截断 */
    height: 30px; /* 设置子元素的高度 */
    margin: 5px; /* 设置子元素的外边距 */
    background: #ecf5ff; /* 设置背景颜色 */
    line-height: 30px;
    align-content: flex-start;
    border-color: #b3d8ff;
    border-radius: 6px;
  }
}
</style>